import { createContext, useReducer } from 'react'
import { type StatsProviderProps, type StatsDataContextProps, type StatsDispatchContextProps } from 'src/types'

import { reducer } from './reducer'
import { defaultStats } from './defaults'

export const StatsDataContext = createContext<StatsDataContextProps>({ stats: defaultStats })
StatsDataContext.displayName = 'StatsDataContext'

export const StatsDispatchContext = createContext<StatsDispatchContextProps>({ dispatchStats: () => null })
StatsDispatchContext.displayName = 'StatsDispatchContext'

export const StatsProvider = ({ children }: StatsProviderProps) => {
  const [stats, dispatchStats] = useReducer(reducer, defaultStats)
  
  return (
    <StatsDataContext.Provider value={{ stats }}>
      <StatsDispatchContext.Provider value={{ dispatchStats }}>
        {children}
      </StatsDispatchContext.Provider>
    </StatsDataContext.Provider>
  )
}
